import moment from "moment"

import defaultProfilePicture from "../../../../assets/images/users/default-profile-picture.png"
import { isSortingEvent } from "pages/EventsManagement/EventStage"

export const getOrganizerDisplayName = (organizer, club) => {
  if (organizer?.role === "club") {
    return (
      club?.clubName ||
      club?.clubInfo?.businessName ||
      organizer?.clubInfo?.businessName ||
      organizer?.organizerInfo?.companyName ||
      "Unnamed club organizer"
    )
  }

  return (
    [organizer?.firstName, organizer?.lastName].filter(Boolean).join(" ") ||
    "Unnamed organizer"
  )
}

// An account's picture lives in its asset folder, by its userId, where the web, SportyaOS and the player editor read and write it.
export const getOrganizerProfileImage = organizer => {
  const image = organizer?.profilePicture

  if (!image) return defaultProfilePicture
  if (/^https?:\/\//i.test(image)) return image

  return `${process.env.REACT_APP_API_URL}/assets/accounts/${organizer.userId}/${image}`
}

export const getOrganizerSportRows = sports =>
  Object.entries(sports || {})
    .map(([sport, levels]) => ({
      sport,
      singles: levels?.singles?.gameLevel ?? null,
      doubles: levels?.doubles?.gameLevel ?? null,
    }))
    .filter(({ singles, doubles }) => singles !== null || doubles !== null)

export const getPaginationWindow = (page, totalPages, windowSize = 5) => {
  if (!totalPages || totalPages < 1) return []

  const size = Math.min(windowSize, totalPages)
  const half = Math.floor(size / 2)
  const start = Math.max(1, Math.min(page - half, totalPages - size + 1))

  return Array.from({ length: size }, (_, index) => start + index)
}

export const paginateItems = (items = [], page = 1, pageSize = 7) => {
  const safePageSize = Math.max(Number(pageSize) || 1, 1)
  const totalPages = Math.ceil(items.length / safePageSize)
  const safePage = Math.min(
    Math.max(Number(page) || 1, 1),
    Math.max(totalPages, 1)
  )
  const offset = (safePage - 1) * safePageSize

  return {
    items: items.slice(offset, offset + safePageSize),
    page: safePage,
    totalPages,
    start: items.length ? offset + 1 : 0,
    end: Math.min(offset + safePageSize, items.length),
  }
}

const formatTournamentMoment = value =>
  value && moment(value).isValid() ? moment(value).format("D MMM YYYY, HH:mm") : null

// A Sorting List tournament opens registration at pre-registration; the Main List opens later.
export const getTournamentRegistrationOpening = tournament => {
  const registration = formatTournamentMoment(tournament?.registrationOpensAt)
  const preRegistration = isSortingEvent(tournament)
    ? formatTournamentMoment(tournament?.preRegistrationOpensAt)
    : null

  if (!preRegistration) return { opensAt: registration, detail: null }

  return {
    opensAt: preRegistration,
    detail: registration
      ? `Pre-registration · Registration ${registration}`
      : "Pre-registration",
  }
}

export const formatMembership = membership => {
  const plan = membership?.plan || "free"
  const endDate = membership?.endDate

  return {
    plan,
    endDate: endDate && moment(endDate).isValid()
      ? moment(endDate).format("D MMM YYYY")
      : null,
  }
}
